import React from "react";
import GoogleSignin from "../img/google-button.png";
import { auth } from "../firebase";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import CopyCode from "./CopyCode";

const Welcome = () => {
  const blogUrl =
    "https://tech.timonwa.com/blog/create-multi-room-chat-app-using-react-firebase";
  const termsUrl = "https://tech.timonwa.com/terms";

  const googleSignIn = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider);
  };

  return (
    <main className="welcome">
      <div className="welcome-card">
        <span className="welcome-tag">Updated for React 19 + Firebase v12</span>
        <h2>Welcome to React Chat.</h2>
        <p>
          Sign in with Google to chat with fellow React developers in public or
          private rooms.
        </p>
        <button className="sign-in" type="button" onClick={googleSignIn}>
          <img src={GoogleSignin} alt="sign in with google" />
        </button>
        <p className="welcome-disclaimer">
          <strong>Updated guide:</strong> The{" "}
          <a href={blogUrl} target="_blank" rel="noreferrer">
            2026 walkthrough
          </a>{" "}
          is on my blog. Looking for the original 2023 version?{" "}
          <a
            href="https://tech.timonwa.com/blog/building-a-real-time-chat-app-with-reactjs-and-firebase"
            target="_blank"
            rel="noreferrer">
            Read it on my blog
          </a>{" "}
          (originally published on{" "}
          <a
            href="https://www.freecodecamp.org/news/building-a-real-time-chat-app-with-reactjs-and-firebase/"
            target="_blank"
            rel="noreferrer">
            freeCodeCamp
          </a>
          ), and use the legacy code on the{" "}
          <a
            href="https://github.com/Timonwa/react-chat/tree/freecodecamp-original"
            target="_blank"
            rel="noreferrer">
            freecodecamp-original
          </a>{" "}
          branch.
        </p>
        <p className="welcome-disclaimer welcome-disclaimer--muted">
          Signing in stores your Google email, name, avatar, and messages in
          Firebase so the chat can work. Demo data is cleared on the 1st of each
          month. See the{" "}
          <a href={termsUrl} target="_blank" rel="noreferrer">
            terms of use
          </a>{" "}
          for details.
        </p>
      </div>

      <div className="welcome-card">
        <div className="demo-rooms">
          <h3>Demo Private Rooms</h3>
          <p>Try these pre-created private rooms to test the feature:</p>
          <div className="room-codes">
            <div className="room-code">
              <strong>React Tips:</strong> <CopyCode code="0695-RJ9I" />
            </div>
            <div className="room-code">
              <strong>Firebase Chat:</strong> <CopyCode code="P8IB-A98Z" />
            </div>
            <div className="room-code">
              <strong>Modern UI:</strong> <CopyCode code="64KN-6OXP" />
            </div>
          </div>
          <p className="room-code-note">
            Copy a code above and paste it to join the private room.
          </p>
        </div>
      </div>
    </main>
  );
};

export default Welcome;
